module.exports = __webpack_public_path__ + "img/refund_ready.7a0096be.png";